import React from 'react'
import {
    Flex,
    Text,
    Box,
    useMediaQuery,
    Accordion,
    AccordionPanel,
    AccordionButton,
    AccordionItem,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ChevronDown} from '../../icons'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import {FormattedMessage} from 'react-intl'
import {useMultiStyleConfig} from '@chakra-ui/react'

const RecipeUtensils = ({allUtensils = []}) => {
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(767.9)})`)
    const accordionStyles = useStyleConfig('Accordion')
    const styles = useMultiStyleConfig('RecipeDetails')
    const recipeUtensilsStyles = styles?.ingredientsMenu?.recipeUtensilsStyles

    const content = !isMobile ? (
        allUtensils.length > 0 ? (
            <Box {...recipeUtensilsStyles?.container}>
                <Flex {...recipeUtensilsStyles?.flex}>
                    <Text as="h2" {...recipeUtensilsStyles?.title}>
                        <FormattedMessage
                            id="recipes.details_page.utensils.title"
                            defaultMessage="Utensils"
                        />
                    </Text>
                    <Text {...recipeUtensilsStyles?.text}>
                        {allUtensils
                            .filter(Boolean)
                            .map((u) => u.trim())
                            .join(', ')}
                    </Text>
                    <Flex {...recipeUtensilsStyles?.divider}></Flex>
                </Flex>
            </Box>
        ) : (
            <></>
        )
    ) : (
        <Flex {...accordionStyles?.accordionContainer}>
            <Accordion w="100%" allowToggle>
                <AccordionItem {...accordionStyles?.item} paddingX="0">
                    <Flex w="100%" justifyContent="space-between">
                        <AccordionButton {...accordionStyles?.button}>
                            <Box
                                flex="1"
                                textAlign="left"
                                textStyle="head-medium"
                                fontWeight="semibold"
                            >
                                <FormattedMessage
                                    id="recipes.details_page.utensils.title"
                                    defaultMessage="Utensils"
                                />
                            </Box>
                            <ChevronDown />
                        </AccordionButton>
                    </Flex>

                    <AccordionPanel {...accordionStyles?.panel}>
                        <Text {...recipeUtensilsStyles?.mobileText}>{allUtensils.join(', ')}</Text>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </Flex>
    )

    return content
}

RecipeUtensils.propTypes = {
    allUtensils: PropTypes.array,
}

export default RecipeUtensils
